import Button from 'components/button/Button';
import { Modal } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ModalFooterContainer } from './OwnerPermissionsModal.styles';

interface OwnerModalFooterProps {
  onClose: () => void;
}

const OwnerPermissionsModalFooter = ({ onClose }: OwnerModalFooterProps) => {
  const { t } = useTranslation();
  const { isSubmitting, isDirty } = useFormState();

  const isDisabled = isSubmitting || !isDirty;

  return (
    <Modal.Footer>
      <ModalFooterContainer>
        <Button bsStyle="default" onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button bsStyle="primary" type="submit" disabled={isDisabled}>
          {t('common.save')}
        </Button>
      </ModalFooterContainer>
    </Modal.Footer>
  );
};

export default OwnerPermissionsModalFooter;
